import { Navigate, Outlet, useNavigate } from 'react-router-dom';

import Auth from '../../../stores/authentication';
import { Loader } from '../../shared/Loader';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { QuadAdminSecureLayout } from './QuadAdminSecureLayout';
import { RolesEnum } from '../../../utilities/Constants';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useSignalRContext } from '../../../contexts/SignalRContext';

const QuadAdminSecureRoute = () => {
    const { isInitialized, isLoadingUser, isLoggedIn, user } = useAuthContext();
    const { alertHub } = useSignalRContext();
    const navigate = useNavigate();

    if (!isInitialized && isLoadingUser) {
        return <Loader />;
    }

    if (!Auth.isInApplicationRole(RolesEnum.SameCaseAdmin, user)) {
        navigate(LocalRoutes.AccessDenied);
    }

    return isLoggedIn && isInitialized ? (
        <QuadAdminSecureLayout
            alertHubConnection={alertHub}
            isLoggedIn={isLoggedIn}
            user={user ?? { active: false }}
        >
            <Outlet />
            {isLoadingUser && <Loader />}
        </QuadAdminSecureLayout>
    ) : (
        <Navigate to={LocalRoutes.Login} />
    );
};

export default QuadAdminSecureRoute;
